import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';

function auth() { return { headers: { Authorization: `Bearer ${localStorage.getItem('adminToken')}` } }; }
function ts(d) { if (!d) return '—'; const m = Math.floor((Date.now()-new Date(d))/60000); return m<60?`${m}m ago`:m<1440?`${Math.floor(m/60)}h ago`:`${Math.floor(m/1440)}d ago`; }

export default function Enrollment() {
  const [tokens,   setTokens]   = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [msg,      setMsg]      = useState({ text:'', type:'' });
  const [showForm, setShowForm] = useState(false);
  const [qrModal,  setQrModal]  = useState(null);
  const [form, setForm] = useState({ name:'', description:'', patchRing:'production', deviceType:'workstation', maxUses:'', expiresAt:'' });

  function flash(t,type='success') { setMsg({text:t,type}); setTimeout(()=>setMsg({text:'',type:''}),4000); }

  const load = useCallback(async () => {
    try { const r = await axios.get('/api/enrollment/tokens', auth()); setTokens(r.data); }
    catch(e) { flash(e.response?.data?.error||'Failed to load','error'); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { load(); }, [load]);

  async function create(e) {
    e.preventDefault();
    try {
      await axios.post('/api/enrollment/tokens', { ...form, maxUses: form.maxUses||null, expiresAt: form.expiresAt||null }, auth());
      flash('Enrollment token created'); setShowForm(false); setForm({ name:'', description:'', patchRing:'production', deviceType:'workstation', maxUses:'', expiresAt:'' }); load();
    } catch(e) { flash(e.response?.data?.error||'Failed to create','error'); }
  }

  async function del(id) {
    if (!window.confirm('Delete this token?')) return;
    try { await axios.delete(`/api/enrollment/tokens/${id}`, auth()); flash('Deleted'); load(); }
    catch(e) { flash('Failed to delete','error'); }
  }

  async function showQr(t) {
    try {
      const r = await axios.get(`/api/enrollment/tokens/${t.id}/qr`, auth());
      setQrModal({ ...r.data, token: t });
    } catch(e) { flash('Failed to generate QR','error'); }
  }

  function copyText(text) {
    navigator.clipboard?.writeText(text).then(()=>flash('Copied!')).catch(()=>flash('Copy failed','error'));
  }

  const RING_COLOR = { test:'#7c3aed', pilot:'#d97706', production:'#16a34a' };
  const RING_BG    = { test:'#ede9fe', pilot:'#fef3c7', production:'#dcfce7' };

  return (
    <div style={{padding:'24px'}}>
      {msg.text && (
        <div style={{padding:'10px 16px',borderRadius:8,marginBottom:16,background:msg.type==='error'?'#fee2e2':'#dcfce7',color:msg.type==='error'?'#dc2626':'#16a34a',fontWeight:600}}>
          {msg.type==='error'?'✘':'✔'} {msg.text}
        </div>
      )}

      {/* Header */}
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:24}}>
        <div>
          <h2 style={{margin:0,fontSize:20,fontWeight:700,color:'#1e293b'}}>Device Enrollment</h2>
          <p style={{margin:'4px 0 0',color:'#64748b',fontSize:14}}>Generate QR codes and one-click install links for easy agent deployment</p>
        </div>
        <button onClick={()=>setShowForm(true)} style={{background:'#1e40af',color:'#fff',border:'none',borderRadius:8,padding:'10px 20px',fontWeight:600,cursor:'pointer',fontSize:14}}>
          + New Enrollment Token
        </button>
      </div>

      {/* How-to banner */}
      <div style={{background:'#f0f9ff',border:'1px solid #bae6fd',borderRadius:10,padding:'16px 20px',marginBottom:24}}>
        <div style={{fontWeight:700,color:'#0369a1',marginBottom:8}}>How to enroll a device</div>
        <div style={{display:'flex',gap:32,flexWrap:'wrap'}}>
          {[
            ['1. Create Token','Click "+ New Enrollment Token" and set ring/type'],
            ['2. Share Install Link','Copy the install command or scan QR code on the device'],
            ['3. Run on Device','Open PowerShell as Admin and paste the command'],
            ['4. Done!','Device appears online within 30 seconds'],
          ].map(([t,d])=>(
            <div key={t} style={{minWidth:160}}>
              <div style={{fontWeight:600,color:'#0c4a6e',fontSize:13}}>{t}</div>
              <div style={{color:'#0369a1',fontSize:12,marginTop:2}}>{d}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Token list */}
      {loading ? <div style={{textAlign:'center',padding:40,color:'#64748b'}}>Loading...</div> : (
        tokens.length === 0 ? (
          <div style={{textAlign:'center',padding:60,color:'#94a3b8'}}>
            <div style={{fontSize:48,marginBottom:12}}>📱</div>
            <div style={{fontSize:16,fontWeight:600}}>No enrollment tokens yet</div>
            <div style={{fontSize:14,marginTop:8}}>Create one to start enrolling devices with a QR code</div>
          </div>
        ) : (
          <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fill,minmax(420px,1fr))',gap:16}}>
            {tokens.map(t => (
              <div key={t.id} style={{background:'#fff',border:'1px solid #e2e8f0',borderRadius:12,padding:20}}>
                <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:12}}>
                  <div>
                    <div style={{fontWeight:700,fontSize:15,color:'#1e293b'}}>{t.name}</div>
                    {t.description && <div style={{fontSize:12,color:'#64748b',marginTop:2}}>{t.description}</div>}
                  </div>
                  <div style={{display:'flex',gap:6}}>
                    <span style={{background:RING_BG[t.patchRing]||'#f1f5f9',color:RING_COLOR[t.patchRing]||'#64748b',borderRadius:6,padding:'2px 8px',fontSize:11,fontWeight:700}}>{t.patchRing}</span>
                    <span style={{background:'#f1f5f9',color:'#475569',borderRadius:6,padding:'2px 8px',fontSize:11,fontWeight:700}}>{t.deviceType}</span>
                  </div>
                </div>

                <div style={{display:'flex',gap:20,marginBottom:14,fontSize:12,color:'#64748b'}}>
                  <span>📊 {t.usedCount} used{t.maxUses?` / ${t.maxUses} max`:' (unlimited)'}</span>
                  <span>🕐 Created {ts(t.createdAt)}</span>
                  {t.expiresAt && <span>⏰ Expires {new Date(t.expiresAt).toLocaleDateString()}</span>}
                </div>

                {/* Install command */}
                <div style={{background:'#0f172a',borderRadius:8,padding:'10px 14px',marginBottom:14,fontSize:12,fontFamily:'monospace',color:'#e2e8f0',wordBreak:'break-all',lineHeight:1.5}}>
                  {t.installCmd || `irm ${t.installUrl} | iex`}
                </div>

                <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
                  <button onClick={()=>copyText(t.installCmd||t.installUrl)} style={{flex:1,background:'#f1f5f9',border:'1px solid #e2e8f0',borderRadius:7,padding:'7px 12px',fontSize:12,fontWeight:600,cursor:'pointer',color:'#475569'}}>
                    📋 Copy Command
                  </button>
                  <button onClick={()=>showQr(t)} style={{flex:1,background:'#1e40af',border:'none',borderRadius:7,padding:'7px 12px',fontSize:12,fontWeight:600,cursor:'pointer',color:'#fff'}}>
                    📱 Show QR Code
                  </button>
                  <button onClick={()=>del(t.id)} style={{background:'#fee2e2',border:'none',borderRadius:7,padding:'7px 10px',fontSize:12,cursor:'pointer',color:'#dc2626'}}>
                    🗑
                  </button>
                </div>
              </div>
            ))}
          </div>
        )
      )}

      {/* Create modal */}
      {showForm && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'#fff',borderRadius:14,padding:32,width:480,maxWidth:'95vw'}}>
            <h3 style={{margin:'0 0 20px',fontSize:18,fontWeight:700}}>New Enrollment Token</h3>
            <form onSubmit={create}>
              {[
                ['Token Name*','name','text','e.g. Floor 3 Rollout'],
                ['Description','description','text','Optional description'],
              ].map(([label,key,type,ph])=>(
                <div key={key} style={{marginBottom:14}}>
                  <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4,color:'#374151'}}>{label}</label>
                  <input value={form[key]} onChange={e=>setForm({...form,[key]:e.target.value})} placeholder={ph} required={label.includes('*')} type={type}
                    style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box'}} />
                </div>
              ))}
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:14}}>
                <div>
                  <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4,color:'#374151'}}>Patch Ring</label>
                  <select value={form.patchRing} onChange={e=>setForm({...form,patchRing:e.target.value})} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14}}>
                    <option value="test">Test</option>
                    <option value="pilot">Pilot</option>
                    <option value="production">Production</option>
                  </select>
                </div>
                <div>
                  <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4,color:'#374151'}}>Device Type</label>
                  <select value={form.deviceType} onChange={e=>setForm({...form,deviceType:e.target.value})} style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14}}>
                    <option value="workstation">Workstation</option>
                    <option value="server">Server</option>
                    <option value="other">Other</option>
                  </select>
                </div>
              </div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:14,marginBottom:20}}>
                <div>
                  <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4,color:'#374151'}}>Max Uses (blank=unlimited)</label>
                  <input type="number" value={form.maxUses} onChange={e=>setForm({...form,maxUses:e.target.value})} min="1" placeholder="Unlimited"
                    style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box'}} />
                </div>
                <div>
                  <label style={{display:'block',fontWeight:600,fontSize:13,marginBottom:4,color:'#374151'}}>Expires (blank=never)</label>
                  <input type="date" value={form.expiresAt} onChange={e=>setForm({...form,expiresAt:e.target.value})}
                    style={{width:'100%',padding:'9px 12px',border:'1px solid #d1d5db',borderRadius:8,fontSize:14,boxSizing:'border-box'}} />
                </div>
              </div>
              <div style={{display:'flex',gap:10,justifyContent:'flex-end'}}>
                <button type="button" onClick={()=>setShowForm(false)} style={{padding:'10px 20px',border:'1px solid #d1d5db',borderRadius:8,background:'#fff',cursor:'pointer',fontWeight:600}}>Cancel</button>
                <button type="submit" style={{padding:'10px 20px',background:'#1e40af',color:'#fff',border:'none',borderRadius:8,fontWeight:600,cursor:'pointer'}}>Create Token</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* QR Modal */}
      {qrModal && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000}}>
          <div style={{background:'#fff',borderRadius:14,padding:32,width:420,maxWidth:'95vw',textAlign:'center'}}>
            <h3 style={{margin:'0 0 4px',fontSize:18,fontWeight:700}}>{qrModal.name}</h3>
            <p style={{margin:'0 0 20px',color:'#64748b',fontSize:13}}>Scan with a phone camera or MDM provisioning tool</p>
            <img src={qrModal.qr} alt="QR Code" style={{width:260,height:260,border:'2px solid #e2e8f0',borderRadius:12,marginBottom:16}} />
            <div style={{background:'#f8fafc',borderRadius:8,padding:'10px 14px',marginBottom:16,fontSize:11,fontFamily:'monospace',color:'#475569',wordBreak:'break-all',textAlign:'left'}}>
              {qrModal.installUrl}
            </div>
            <div style={{display:'flex',gap:10,justifyContent:'center'}}>
              <button onClick={()=>copyText(qrModal.installUrl)} style={{padding:'9px 18px',background:'#f1f5f9',border:'1px solid #e2e8f0',borderRadius:8,fontWeight:600,cursor:'pointer',fontSize:13}}>📋 Copy URL</button>
              <button onClick={()=>setQrModal(null)} style={{padding:'9px 18px',background:'#1e40af',color:'#fff',border:'none',borderRadius:8,fontWeight:600,cursor:'pointer',fontSize:13}}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
